var usercentricsLoaded = false;
function loadUsercentrics() {
  if (usercentricsLoaded) return;
  usercentricsLoaded = true;

  var stub_script = document.createElement("script");
  stub_script.src = "https://web.cmp.usercentrics.eu/tcf/stub.js";
  (
    document.getElementsByTagName("head")[0] || document.documentElement
  ).appendChild(stub_script);

  var currentScript = document.querySelector('script[data-uc-settings-id]');
  var settingsId = currentScript ? currentScript.getAttribute('data-uc-settings-id') : 'HpS_E06Tx';

  var usercentrics_script = document.createElement("script");
  usercentrics_script.id = "usercentrics-cmp";
  usercentrics_script.async = true;
  usercentrics_script.setAttribute("data-settings-id", settingsId);
  usercentrics_script.src = "https://web.cmp.usercentrics.eu/ui/loader.js";
  (
    document.getElementsByTagName("head")[0] || document.documentElement
  ).appendChild(usercentrics_script);

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }], 
    error => {
      if (error) throw error
      console.log('** Shopify Consent Tracking API loaded');
      const syncTrackingConsent = consentObj => {
        window.Shopify.customerPrivacy.setTrackingConsent(consentObj, () => {
          console.log("** UC consent synced with Shopify Customer Privacy API")
          console.log("- Shopify consent:")
          console.log(window.Shopify.customerPrivacy.currentVisitorConsent())
          console.log("--------------------------")
        })
      }
      window.addEventListener("UC_CONSENT", e => {
        const services = Object.values(e.detail.services)
        const ucAnalytics = services.find(service => service.name == 'Shopify Analytics')
        const ucMarketing = services.find(service => service.name == 'Shopify Marketing')
        const ucPreferences = services.find(service => service.name == 'Shopify Preferences')
        if (ucAnalytics && ucMarketing && ucPreferences) {
          const analyticsConsent = ucAnalytics.consent.given
          const marketingConsent = ucMarketing.consent.given
          const preferencesConsent = ucPreferences.consent.given
          console.log('** Usercentrics consent:')
          console.log("- status: " + e.detail.consent.status)
          console.log("- updatedBy: " + e.detail.consent.updatedBy)
          console.log("- Analytics: " + analyticsConsent)
          console.log("- Marketing: " + marketingConsent)
          console.log("- Preferences: " + preferencesConsent)
          const isOptOut = window.Shopify.customerPrivacy.saleOfDataRegion()
          console.log("** is using Opt-Out framework: " + isOptOut)
          if (isOptOut) { 
            const val = e.detail.consent.status == 'ALL_DENIED' ? false : true
            syncTrackingConsent({
              analytics: val, 
              marketing: val, 
              preferences: val, 
              sale_of_data: val
            })
          } else {     
            syncTrackingConsent({
              analytics: analyticsConsent,
              marketing: marketingConsent,
              preferences: preferencesConsent,
            })
          }
        } else {
          throw 'No DPSs found (Shopify Analytics, Shopify Marketing, Shopify Preferences)'
        }
      })
    }
  )
}
loadUsercentrics();